<template>
    <div class="col-md-12">
        <button class="btn btn-success btn-add" @click="openModalGroup()">
            <i class="fas fa-users"></i> Adicionar novo grupo
        </button>

        <b-row>
            <b-col md="12">
                <b-table striped hover bordered sort-icon-left show-empty :items="tbData" :fields="fields"
                    :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered"
                    :current-page="currentPage" :per-page="perPage" thead-class="font-weight-bold">

                    <template v-if="loading" #empty>
                        <div class="text-center">
                            <b-spinner variant="dark" small></b-spinner> Processando, por favor, aguarde...
                        </div>
                    </template>

                    <template v-else #empty>
                        <h6 class="empty-message">Nenhum resultado encontrado.</h6>
                    </template>

                    <template #cell(members)="data">
                        <span
                            v-if="data.item.members && data.item.members.length > 0"
                            v-for="member in data.item.members"
                            :key="member.id"
                            class="badge badge-member"
                        >
                            {{ member.name }}
                        </span>
                        <span v-else class="text-muted">—</span>
                    </template>

                    <template v-slot:cell(view-button)="{ item }">
                        <span>
                            <b-btn class="btn-view" @click.prevent="openModalGroup(item)">
                                <i class="far fa-eye" aria-hidden="true"></i>
                            </b-btn>
                        </span>
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <b-row class="justify-content-between">
            <b-col md="4">
                <b-form-group
                    label="Registros por página"
                    label-for="per-page-select"
                    label-cols-md="6"
                    label-align-sm="right"
                    label-size="sm"
                    class="mb-0 align-self-center"
                >
                    <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" size="md"
                class="my-0"></b-pagination>
            </b-col>
        </b-row>

        <WppGroupModal ref="addGroupModal" @updateGroupTable="updateTable" @deleteGroup="deleteGroup"></WppGroupModal>
    </div>
</template>

<script>
import axios from 'axios';
import WppGroupModal from './WppGroupModal.vue';

export default {
    name: "WppGroupsTable",
    components: { WppGroupModal },
    data() {
        return {
            tbData: [],
            loading: false,
            fields: [
                {
                    key: 'name',
                    label: 'Nome',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'members',
                    label: 'Membros',
                    sortable: false,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'view-button',
                    label: 'Visualizar',
                    sortable: false,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff', width: '100px' }
                },
            ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Ver mais" }],
            sortBy: '',
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
        }
    },
    created() {
        this.getDataTable();
    },
    methods: {
        openModalGroup(value = null) {
            this.$refs.addGroupModal.openModal(value);
        },
        refresh() {
            this.getDataTable();
        },
        getDataTable() {
            this.loading = true;
            axios.get("/settings/contacts/groups/type/whatsapp")
                .then(response => {
                    this.tbData = response.data.map(group => ({
                        ...group,
                        members: group.contacts,
                    }));
                    this.totalRows = response.data.length;
                })
                .catch(error => {
                    console.error(error);
                    Swal.fire({ type: 'error', text: 'Falha ao carregar grupos!' });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        updateTable(data) {
            if (!data.id) return;
            const found = this.tbData.find(el => el.id === data.id);
            if (found) {
                Object.assign(found, data);
            } else {
                this.tbData.push(data);
                this.totalRows = this.tbData.length;
            }
            this.$emit('changed');
        },
        deleteGroup(id) {
            this.tbData = this.tbData.filter(el => el.id !== id);
            this.totalRows = this.tbData.length;
            this.$emit('changed');
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
    }
}
</script>

<style scoped>
.btn-add {
    border-radius: 2px;
}

.empty-message {
    text-align: center;
}

.btn-view {
    border-radius: 3px;
}

.badge-member {
    margin: 0 4px;
    font-size: 0.85em;
    background-color: #147738;
    color: #ffffff;
}
</style>